import { useField } from "formik";
import { Checkbox as NeetoUICheckbox } from "neetoui";

const Checkbox = ({ name, optionIndex }) => {
  const checkboxName = name.replace(".label", ".selected");
  const [{ value }, _, { setValue }] = useField(checkboxName);

  return (
    <div className="flex h-8 flex-shrink-0 items-center">
      <NeetoUICheckbox
        checked={value || false}
        data-testid={`checkbox-option-${optionIndex}`}
        onChange={e => {
          setValue(e.target.checked);
        }}
      />
    </div>
  );
};

export default Checkbox;
